export default "__VITE_ASSET__B09C6lRY__"